<template>
  <div class="add-form">
    <Form ref="addForm" :model="form" :rules="diyData.rules" :label-width="100">
      <FormItem label="是否显示">
        <RadioGroup v-model="form.status">
          <Radio label="1">显示</Radio>
          <Radio label="2">隐藏</Radio>
        </RadioGroup>
      </FormItem>
      <div class="tag-title">快捷菜单</div>
      <Row>
        <Col span="8" v-for="(item, index) in form.menu" :key="index">
          <div class="tag-title">{{ item.title }}</div>
          <FormItem label="选择文章">
            <Select filterable v-model="item.article_id" placeholder="请选择文章">
              <Option
                v-for="(item, index) in apiData.articleList"
                :key="index"
                :label="item.title"
                :value="item.id"
              ></Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <FormItem>
        <Button type="primary" style="width: 90px; margin-right: 20px" @click="submit">保存</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import * as apiArticle from '@/api/article'
import * as apiSetting from '@/api/setting'
export default {
  name: 'add-form',
  data () {
    return {
      query: {},
      search: {},
      diyDom: {},
      // 表单数据
      form: {
        status: '1',
        menu: [
          {
            title: '组织架构',
            type: '1', // 类型1文章聊天，2跳转目的页面
            article_id: '' // 文章id
          },
          {
            title: '关于协会',
            type: '2', // 类型1文章聊天，2跳转目的页面
            article_id: '' // 文章id
          }
        ]
      },
      diyData: {
        rules: {}
      },
      apiData: {
        articleList: []
      }
    }
  },
  computed: {},
  methods: {
    // 获取详情
    getDetail () {
      this.$store.commit('setSpinShow', true)
      apiSetting
        .apiGetSystem('menu')
        .then(res => {
          this.form.status = res.data.status
          this.form.menu = res.data.menu
        })
        .finally(() => this.$store.commit('setSpinShow', false))
    },
    // 获取文章不分页
    getArticle () {
      apiArticle.apiArticleList().then(res => {
        this.apiData.articleList = res.data
      })
    },
    submit () {
      apiSetting
        .apiSetSystem('menu', {
          menu: {
            menu: this.form.menu,
            status: this.form.status
          }
        })
        .then(res => {
          this.$Message.success('保存成功')
          this.$bus.$emit('on-change')
          this.getDetail()
        })
    }
  },
  mounted () {
    this.getDetail()
    this.getArticle()
  }
}
</script>

<style scoped lang="less">
  .add-form {
    border: 1px solid #ededed;
    margin: 0 20px;
    padding: 26px 20px;

    .title {
      border-left: 5px solid #2d8cf0;
      padding: 0 0 0 10px;
      margin: 0 20px 20px;
      font-weight: bold;
    }
    .tips-item {
      display: flex;
      margin-bottom: 10px;
    }
    .delete {
      margin-left: 10px;
      cursor: pointer;
      display: flex;
      align-items: center;
      color: red;
    }
    .add {
      margin-left: 10px;
      cursor: pointer;
      display: flex;
      align-items: center;
      color: #2d8cf0;
    }
  }
</style>
